import styled from 'styled-components';
import { pageChildBannerStyles } from 'pages/usage/usage.style';

export const Image = styled.img`
  height: 400px;
  border-radius: ${props => props.theme.borderRadii.large};

  ${props => props.theme.media.small`
    border-radius: 0;
    ${pageChildBannerStyles}
  `}
`;
